import useMenu from './useMenu'
import * as R from 'ramda'
import type { ManifestDetail } from '@/typings/detail'
import { getProductCodeByUrl } from '@/utils/common'
const { domain } = getProductCodeByUrl()
const TabKey = `${domain.toUpperCase()}_TAB_INFO__`
const ActiveTabKey = `${domain.toUpperCase()}_ACTIVE_TAB_INFO__`

type TabDetail = { key: any; value: Partial<ManifestDetail>; route: any }
type TabsList = Record<string, TabDetail[]>
const tabs = useStorage<TabsList>(TabKey, {}, window.sessionStorage)
const activeTabName = useStorage(ActiveTabKey, 'Draft', window.sessionStorage)

export default () => {
  const { activeMenuName } = useMenu()
  const router = useRouter()
  const route = useRoute()

  const currentTabs = computed<TabDetail[]>(() => {
    return tabs.value[activeMenuName.value]
  })

  const addTab = ({
    value,
    route,
    callback,
  }: {
    value: Partial<ManifestDetail>
    route: any
    callback?: () => any
  }) => {
    const { activeMenuName } = useMenu()
    const timestamp = new Date().getTime().toString()
    const id = route.params?.id
    const key = id ? id : timestamp
    activeTabName.value = key
    if (!tabs.value[activeMenuName.value]) {
      tabs.value[activeMenuName.value] = []
    }
    if (
      !tabs.value[activeMenuName.value].find(
        (item) => item.key === key && item.route.name === route.name,
        // item?.route.query.action === route?.query.action,
      )
    ) {
      tabs.value[activeMenuName.value].push({
        value,
        route,
        key,
      })
    }
    if (callback && !callback()) return
    router.push(route)

    // 最多保留5个tab
    // tabs.value[activeMenuName.value] = Object.fromEntries(
    //   Object.entries(tabs.value[activeMenuName.value]).slice(-5),
    // )
  }

  const addMultiTab = (list: TabDetail[]) => {
    if (!tabs.value[activeMenuName.value]) {
      tabs.value[activeMenuName.value] = []
    }
    list.forEach((item, index) => {
      addTab({
        ...item,
        callback() {
          return index === list.length - 1
        },
      })
    })
  }

  const getTab = (key: string, name?: string): TabDetail => {
    const currentRouteName = name || route.name
    const tab = tabs.value[activeMenuName.value]?.find(
      (item) => item.key === key && item.route.name === currentRouteName,
    )
    return tab as TabDetail
  }

  const setTab = (value: Partial<TabDetail>, key?: string, name?: string) => {
    const index = tabs.value[activeMenuName.value].findIndex(
      (item) =>
        item.key === (key || activeTabName.value) && item.route.name === name,
    )
    tabs.value[activeMenuName.value][index] = R.mergeDeepRight(
      tabs.value[activeMenuName.value][index],
      value,
    )
  }

  const removeTab = ({
    key = activeTabName.value,
    name,
    routeConfig,
    beforeRemove,
    afterRemove,
  }: {
    key?: string
    name?: string
    routeConfig?: any
    beforeRemove?: () => boolean
    afterRemove?: () => boolean
  } = {}) => {
    if (beforeRemove && !beforeRemove()) return
    const currentRouteName = name || route.name
    const removeIndex = tabs.value[activeMenuName.value].findIndex(
      (item) => item.key === key && item.route.name === currentRouteName,
    )
    tabs.value[activeMenuName.value].splice(removeIndex, 1)
    activeTabName.value = activeMenuName.value
    if (afterRemove && !afterRemove()) return
    router.push({ name: activeMenuName.value, ...routeConfig })
  }

  const hasTab = (key: string = '') => {
    if (!key) return false
    return (
      tabs.value[activeMenuName.value].findIndex((item) => item.key === key) ===
      -1
    )
  }

  const changeTab = ({
    key,
    name,
    beforeChange,
    afterChange,
  }: {
    key?: string
    name?: string
    beforeChange?: () => boolean
    afterChange?: () => boolean
  }) => {
    if (beforeChange && !beforeChange()) return
    const cache = getTab(key as string, name as string)
    if (cache) {
      // activeTabName.value = key
      router.push(cache.route)
    } else {
      // activeTabName.value = activeMenuName.value
      router.push({ name: activeMenuName.value as string })
    }
    if (afterChange && !afterChange()) return
  }
  // 替换当前tab
  const replaceTab = ({
    key,
    name,
    routeConfig,
    value,
  }: {
    key?: string
    name?: string
    routeConfig: any
    value: any
  }) => {
    const cache = getTab(key as string, name as string)
    cache.route = routeConfig
    cache.value = R.mergeDeepRight(cache.value, value)
    router.replace(routeConfig)
  }

  const clearTab = () => {
    tabs.value = {}
    activeTabName.value = 'Draft'
    activeMenuName.value = 'Draft'
  }
  return {
    activeTabName,
    currentTabs,
    addTab,
    addMultiTab,
    setTab,
    getTab,
    removeTab,
    hasTab,
    changeTab,
    clearTab,
    replaceTab,
    tabs,
  }
}
